<template>
    <div class="animated fadeIn">
        <b-card>
            <div class="row justify-content-start">
                <div class="col-md-6 col-sm-12">
                    <div class="callout callout-success">
                        <small class="text-muted">Saldo disponível</small>
                        <h4 class="h4">{{ paymentProviderBalance.balance }}</h4>
                    </div>
                </div>                
            </div>            
        </b-card>
        <!-- <b-card>
            <br />
            <form @submit.prevent="validate">
                <div class="form-row justify-content-start">
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label>Quota transferencias pix:</label>
                            <vue-numeric
                                class="form-control"
                                :separator="vueNumericDefaults.separator"
                                :precision="vueNumericDefaults.decimals"
                                :output-type="vueNumericDefaults.outputType"                                    
                                v-model="config.pixTransferQuota"                                    
                            />                                
                        </div>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label>Quota pagamentos boleto:</label>
                            <vue-numeric
                                class="form-control"
                                :separator="vueNumericDefaults.separator"
                                :precision="vueNumericDefaults.decimals"
                                :output-type="vueNumericDefaults.outputType"                                    
                                v-model="config.bankSlipQuota"                                    
                            />                                
                        </div>
                    </div>                          
                </div>
                <hr class="mt-5" />
                <button type="submit" class="btn btn-primary">Salvar</button>
            </form>
        </b-card> -->
    </div>
</template>
<script>
import domainService from '../../../services/MoneyFlow/moneyOutService'
import editPage from '../../../mixins/editPage'

export default {
    mixins: [editPage],
    data() {
        return {
            paymentProviderBalance: {
                balance: "",
                watingBalance: ""
            },
            vueNumericDefaults: {
                decimals: 0,
                separator: '.',
                outputType: 'Number'
            },
            config: {
                pixTransferQuota: 0,
                bankSlipQuota: 0
            }
        }
    },
    created() {
        this.fetchSummaryData();
        this.fetchPaymentProviderConfig();
    },
    methods: {
        fetchSummaryData() {
            const self = this
            self.showLoading();
            domainService.getPaymentProviderBalance()
                .then(
                (response) => {
                        if (response.status == 204) {
                            self.paymentProviderBalance.balance = "";
                            self.paymentProviderBalance.waitingBalance = "";                            
                        }
                        else {
                            self.paymentProviderBalance.balance = response.data.balance;
                            self.paymentProviderBalance.waitingBalance = response.data.waitingBalance;
                        } 
                        self.hideLoading();                  
                    },
                    () => {}
                );
        },
        fetchPaymentProviderConfig() {
            const self = this
            self.showLoading();
            domainService.getPaymentProviderConfig()
                .then(
                (response) => {
                        if (response.status == 204) {
                            self.config.pixTransferQuota = 0;
                            self.config.bankSlipQuota = 0;
                        }
                        else {
                            self.config.pixTransferQuota = response.data.pixTransferQuota;
                            self.config.bankSlipQuota = response.data.bankSlipQuota;                            
                        } 
                        self.hideLoading();                  
                    },
                    () => {}
                );
        },
        validate() {
            const self = this;
            self.showLoading();
            domainService.savePaymentProviderConfig(this.config).then(() => {
                self.hideLoading()                
            }, (error) => {
                self.hideLoading()
            })
        }
    }
}
</script>